var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('InfoTableBase',{attrs:{"title-key":"table.onlineTutorials","fetch-api":_vm.MaintainNewsApi.getTutorialsList}})}
var staticRenderFns = []

export { render, staticRenderFns }